import initDropdownMenu from "ui/dropdown-menu";
import logger from "utils/logger";
import { qsa } from "utils/utils";

const debugTag = "[PODCAST-DROPDOWN-MENU]";

/**
 * Initializes one or more Dropdown Menu components
 * @param {String} containerSelector
 */
export default function init(containerSelector = ".c-card--podcast") {
  const triggers = qsa(`${containerSelector} .js-dropdown-menu-trigger`);
  logger.info(`${debugTag} triggers: `, triggers);

  triggers.forEach((trigger) => {
    const triggerId = trigger.id;
    if (!trigger) {
      logger.info(`${debugTag} Aborting, trigger not found`);
      return;
    }

    initDropdownMenu(`#${triggerId}`, {
      onToggleFn: () => {
        window.analyticsLayer.push({
          event: "clickEvent",
          clickEvent: {
            type: "button",
            feature: "podcast",
            label: "podcast apps menu"
          }
        });
        return true;
      }
    });
  });
}
